/**
 * English translations for company-related features.
 */

const company = {
  // Error messages per CONTEXT.md
  notMemberError: 'You need to be invited by the company',
  loadingCompany: 'Loading company...',
  noCompany: 'You are not part of any company',
  switchCompany: 'Switch company',

  // Role names
  roles: {
    owner: 'Owner',
    admin: 'Admin',
    agent: 'Agent',
    viewer: 'Viewer',
  },

  // Permission messages
  noPermission: 'You do not have permission for this action',

  // Company info
  companyInfo: 'Company Info',
  teamMembers: 'Team Members',
  usage: 'Usage',
  listingsUsed: '{{used}} of {{max}} listings',
};

export default company;
